import { useEffect } from "react";
import styles from "./App.module.css";
import { LoginScreen } from "./components/auth/LoginScreen";
import { ChatView } from "./components/chat/ChatView";
import { AppShell, EmptyChatPlaceholder } from "./components/layout/AppShell";
import { InstallBanner } from "./components/pwa/InstallBanner";
import { InstanceList } from "./components/roster/InstanceList";
import { useAppStore } from "./store/app";

export function App() {
  const init = useAppStore((s) => s.init);
  const connectionPhase = useAppStore((s) => s.connectionPhase);
  const selectedAriaId = useAppStore((s) => s.selectedAriaId);
  const mobileShowChat = useAppStore((s) => s.mobileShowChat);
  const devMode = useAppStore((s) => s.devMode);
  const contacts = useAppStore((s) => s.contacts);

  useEffect(() => {
    void init();
  }, [init]);

  const showApp =
    connectionPhase === "connected" || (devMode && contacts.length > 0);

  return (
    <div className={styles.appRoot}>
      <InstallBanner />
      <div className={styles.appMain}>
        {!showApp ? (
          <LoginScreen />
        ) : (
          <AppShell
            roster={<InstanceList />}
            chat={selectedAriaId ? <ChatView /> : <EmptyChatPlaceholder />}
            showChatOnMobile={mobileShowChat && !!selectedAriaId}
          />
        )}
      </div>
    </div>
  );
}
